exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ciro-kar-report-table[data-v-dd842984]{width:100%;margin-top:8px}.ciro-kar-report-table>*[data-v-dd842984]{width:100%}", ""]);

// exports
